import { stateName } from './constants';

const localState = state => state[stateName];

export const getAbTestByName = name => state => localState(state)[name];
export const getIsAbTestVariant = (name, variant) => state => {
  var _getAbTestByName;

  return ((_getAbTestByName = getAbTestByName(name)(state)) === null || _getAbTestByName === void 0 ? void 0 : _getAbTestByName.variant) === variant;
};
export const getIsAbTestOn = name => state => getIsAbTestVariant(name, 'on')(state);
export const getIsItemSizeLabelOneAbTestEnabled = state => getIsAbTestOn('more_item_size_label_1')(state);
export const getIsShippingFeesApplyBannerAbTestEnabled = state => getIsAbTestOn('info_banner_shipping_fees_apply_feed')(state);
export const getIsFeedRemovalAbTestEnabled = state => getIsAbTestOn('feed_removal')(state);